import { RootState } from '../../../types/redux';
import { QuestionnaireState } from '../../slices/enrollee/questionnaire-slice';

export const selectQuestionnaire = (state: RootState): QuestionnaireState =>
  state.questionnaire;

export const selectIsDraftReadonly = (state: RootState) =>
  state.questionnaire.readonly;
